import { STATE_LOGIN, STATE_SIGNUP } from 'components/AuthForm';
import GAListener from 'components/GAListener';
import { EmptyLayout, LayoutRoute, MainLayout } from 'components/Layout';
import PageSpinner from 'components/PageSpinner';
import AuthPage from 'pages/AuthPage';
import React from 'react';
import componentQueries from 'react-component-queries';
import { BrowserRouter, Redirect, Route, Switch } from 'react-router-dom';
import './styles/reduction.scss';
import jwt from 'jsonwebtoken'




const CardPage = React.lazy(() => import('pages/CardPage'));
const ChartPage = React.lazy(() => import('pages/ChartPage'));
const Userpage = React.lazy(() => import('pages/User'));
const WidgetPage = React.lazy(() => import('pages/WidgetPage'));
const InspectionPage = React.lazy(() => import('pages/Inspection'))
const InspectionEdit = React.lazy(() => import('pages/InspectionEdit') )
const Dashboard = React.lazy(() => import('pages/Dashboard') )
const Factorordersheet = React.lazy(() => import('pages/Factorordersheet') )
const InspectionReport = React.lazy(() => import('pages/InspectionReport') )
const InspectionReportsummary = React.lazy(() => import('pages/InspectionReportSummary') )
const Defactdescription = React.lazy(() => import('pages/Defactdescription'))
const Viewdocs = React.lazy(() => import('pages/Viewdocs'))
const logout = React.lazy(() => import('pages/Logout'))
const Home = React.lazy(() => import('pages/Home'))
const Userrights = React.lazy(() => import('pages/Userrights'))
const AuditMst = React.lazy(() => import('pages/Auditmst'))
const data = React.lazy(() => import('pages/chartdata'))
const getBasename = () => {
  return `/${process.env.PUBLIC_URL.split('/').pop()}`;
};




class App extends React.Component {
  render() {
    
    return (
      <BrowserRouter basename={getBasename()}>
        <GAListener>
          <Switch>
            <LayoutRoute
              exact
              path="/"
              layout={EmptyLayout}
              component={props => (
                <AuthPage {...props} authState={STATE_LOGIN} />
              )}
            />
            <LayoutRoute
              exact
              path="/signup"
              layout={EmptyLayout}
              component={props => (
                <AuthPage {...props} authState={STATE_SIGNUP} />
              )}
            />

            <MainLayout breakpoint={this.props.breakpoint}>
              <React.Suspense fallback={<PageSpinner />}>
                <Route exact path="/chh" component={data} />
                <Route   exact path="/login" component={AuthPage} />
                <Route extends path="/Dashboard" component={Dashboard} />
                <Route exact path="/Qaparameter" component={CardPage} />
                <Route exact path="/Subcategory" component={WidgetPage} />
             <Route exact path="/user" component={Userpage}  /> 
             <Route exact path="/Factoryordersheet" component={Factorordersheet}  /> 
             <Route exact path="/logout" component={logout}  /> 
             <Route exact path="/Home" component={Home}  /> 
             <Route exact path="/Userrights" component={Userrights}  /> 
             
           
                <Route exact path="/inspection" component={InspectionPage}  />
                <Route exact path="/defactcategory" component={ChartPage} />
                <Route exact path="/inspectionModify" component={InspectionEdit} />
                <Route exact path="/inspection/:id" component={InspectionPage}  />
                <Route exact path="/inspectionsummary" component={InspectionReport}  />
                <Route exact path="/inspectionReport" component={InspectionReportsummary}  />
                <Route exact path="/viewdocs/:id" component={Viewdocs} />
                <Route exact path="/Auditmst" component={AuditMst} />

              </React.Suspense>
            </MainLayout>
            <Redirect to="/" />
          </Switch>
        </GAListener>
      </BrowserRouter>
    );
  }
}

const query = ({ width }) => {
  if (width < 575) {
    return { breakpoint: 'xs' };
  }

  if (576 < width && width < 767) {
    return { breakpoint: 'sm' };
  }

  if (768 < width && width < 991) {
    return { breakpoint: 'md' };
  }

  if (992 < width && width < 1199) {
    return { breakpoint: 'lg' };
  }

  if (width > 1200) {
    return { breakpoint: 'xl' };
  }

  return { breakpoint: 'xs' };
};

export default componentQueries(query)(App);
